export default __webpack_public_path__ + "static/media/Rabbit.2a550228.webm";